import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { api } from '@/api';
import LocaleSwitch from '@shared/ui/LocaleSwitch.jsx';
import PrivacyPolicy from '@shared/ui/PrivacyPolicy.jsx';

/**
 * Privacy policy.
 *
 * The text is the CMS block `privacy_policy`, shared with the app's register
 * popup — the organisers edit it there, and the DPO's wording and its
 * placeholders reach both surfaces without a release.
 */
export default function Privacy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <header className="bg-black border-b border-white/10">
        <div className="h-1 w-full bg-brand" />
        <div className="site-shell px-5 py-3 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-white/40 hover:text-white text-sm label-tag transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> {t('microsite.backHome')}
          </Link>
          <LocaleSwitch />
        </div>
      </header>

      <main className="site-shell px-5 py-10">
        <h1 className="display-lg text-white text-4xl mb-8">{t('microsite.privacyTitle')}</h1>
        <PrivacyPolicy api={api} />
      </main>
    </div>
  );
}
